// Autoplay product-card videos on collection/search grids.
// - Plays when 60% in view, pauses when leaving view
// - Mutes + playsinline for iOS
// - Pauses all other card videos when hovering a different card (nice UX)
// - Respects reduced motion

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!prefersReduced) {
  const scope = document;

  // Observe visibility
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (!(v instanceof HTMLVideoElement)) return;
      if (e.isIntersecting) {
        ensureInlineMuted(v);
        v.play().catch(() => {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.6 });

  // Attach to any product-card videos
  const bind = () => {
    scope.querySelectorAll('product-card video, .product-card video, .card-product video')
      .forEach((v) => io.observe(v));
  };

  // Pause others when hovering one card (optional polish)
  scope.addEventListener('mouseenter', (e) => {
    const card = e.target?.closest?.('product-card, .product-card, .card-product');
    if (!card) return;
    const activeVid = card.querySelector('video');
    if (!activeVid) return;
    document.querySelectorAll('product-card video, .product-card video, .card-product video')
      .forEach((v) => {
        if (v !== activeVid) v.pause();
      });
  }, true);

  // iOS inline helper
  function ensureInlineMuted(v) {
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
  }

  // Run on load + after any AJAX grid refreshes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  document.addEventListener('shopify:section:reorder', bind);
  document.addEventListener('pjax:end', bind);
}
